export const PERMISSION = {
  ADD: 'REQUEST_PURCHASE_ORDER_ADD',
  EDIT: 'REQUEST_PURCHASE_ORDER_EDIT',
  VIEW: 'REQUEST_PURCHASE_ORDER_VIEW',
  REVIEW: 'REQUEST_PURCHASE_ORDER_REVIEW',
  DEL: 'REQUEST_PURCHASE_ORDER_DEL',
  PRINT: 'REQUEST_PURCHASE_ORDER_PRINT',
  ADD_REVIEW: 'REQUEST_PURCHASE_ORDER_ADD_REVIEW',
  DEL_REVIEW: 'REQUEST_PURCHASE_ORDER_DEL_REVIEW',
  ADD_PRODUCT: 'REQUEST_PURCHASE_ORDER_ADD_PRODUCT',
};

export const STATUS_ORDER = {
  NOTORDER: 0,
  ORDERED: 1,
  ALL: 2,
};

export const STATUS_ORDER_OPTIONS = [
  {
    label: 'Tất cả',
    value: STATUS_ORDER.ALL,
  },
  {
    label: 'Đã chuyển PO',
    value: STATUS_ORDER.ORDERED,
  },
  {
    label: 'Chưa chuyển PO',
    value: STATUS_ORDER.NOTORDER,
  },
];

export const STATUS_REVIEW = {
  NOTREVIEW: 0, // không duyệt
  REVIEWED: 1, // đã duyệt
  REVIEWING: 2, // chưa duyệt
  ALL: 3,
};

export const STATUS_REVIEW_OPTIONS = [
  {
    label: 'Tất cả',
    value: STATUS_REVIEW.ALL,
  },
  {
    label: 'Đã duyệt',
    value: STATUS_REVIEW.REVIEWED,
  },
  {
    label: 'Chưa duyệt',
    value: STATUS_REVIEW.REVIEWING,
  },
  {
    label: 'Không duyệt',
    value: STATUS_REVIEW.NOTREVIEW,
  },
];


export const MOCK_INITIAL_VALUES = {
  "company_id": 1,
  "business_request_id": 3,
  "business_receive_id": 1,
  "department_request_id": 1,
  "store_receive_id": 1,
  "supplier_id": 1012
};

export const RP_STATUS = {
  WAITING: 1,
  REJECTED: 2,
  OVER_BUDGET: 3,
}

export const RP_STATUS_OPTIONS = [
  {
    label: 'Chờ duyệt giá',
    value: RP_STATUS.WAITING,
  },
  {
    label: 'Không chọn NCC',
    value: RP_STATUS.REJECTED,
  },
  {
    label: 'Vượt khung giá',
    value: RP_STATUS.OVER_BUDGET,
  },
]

export const RP_STATUS_META = {
  [RP_STATUS.WAITING]: {
    label: 'Chờ duyệt giá',
    className: 'bw_label_outline_warning',
  },
  [RP_STATUS.REJECTED]: {
    label: 'Không chọn NCC',
    className: 'bw_label_outline_danger',
  },
  [RP_STATUS.OVER_BUDGET]: {
    label: 'Vượt khung giá',
    className: 'bw_label_outline_info',
  },
};

export const APPROVE_STATUS = {
  REVIEWED : 1,
  NOTREVIEW : 0,
  NOTYETREVIEW : 2
};

export const ORDER_STATUS = {
  ORDERED : 'Đã chuyển PO',
  NOTYETORDER : 'Chưa chuyển PO',
};

export const ORDER_STATUS_META = {
  [ORDER_STATUS.ORDERED]: {
    label: 'Đã chuyển đơn mua hàng',
    className: 'bw_label_outline_success',
  },
  [ORDER_STATUS.NOTYETORDER]: {
    label: 'Chưa chuyển đơn mua hàng',
    className: 'bw_label_outline_info',
  },
};

export const VAT_RATE_OPTIONS = [
  { label: '0 %', value: 0 },
  { label: '5 %', value: 5 },
  { label: '8 %', value: 8 },
  { label: '10 %', value: 10 },
];
